import ItemThumbnailCarousel from './itemThumbnailCarousel'

export default ItemThumbnailCarousel



// WEBPACK FOOTER //
// ./client/pages/home/itemThumbnailCarousel/index.tsx